import { Button, Col, Row, UncontrolledTooltip } from "reactstrap";
import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import AuthHeader from "../../components/AuthHeader";
import { Link, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiCore } from "../../api/apiCore";
import { useAuth } from "../../context/AuthContext";

const FacebookAuth = () => {
  const [registerWaba, setRegisterWaba] = useState(false);
  const [login, setLogin] = useState(false);
  const { user, logout, updateUser } = useAuth();

  useEffect(() => {
    if (document.getElementById("facebook-jssdk")) return;

    const js = document.createElement("script");
    js.id = "facebook-jssdk";
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    js.async = true;
    js.defer = true;
    js.crossOrigin = "anonymous";

    document.body.appendChild(js);
  }, []);

  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.REACT_APP_FACEBOOK_APP_ID!,
        autoLogAppEvents: true,
        xfbml: true,
        version: process.env.REACT_APP_FACEBOOK_API_VERSION || "v24.0"
      });

      console.log("✅ FB SDK inicializado");

    };
  }, []);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {

      // 🔍 DEBUG CRU (PRIMEIRA LINHA)
      console.log("RAW event.data:", event.data, typeof event.data);

      // 🔒 valida origem
      if (
        event.origin !== "https://www.facebook.com" &&
        event.origin !== "https://web.facebook.com"
      ) {
        return;
      }

      // Embedded Signup SEMPRE manda string
      if (typeof event.data !== "string") return;

      let payload: any;

      try {
        payload = JSON.parse(event.data);
      } catch {
        return;
      }

      console.log("📨 Facebook parsed:", payload);

      if (payload.type !== "WA_EMBEDDED_SIGNUP") return;

      if (payload.event === "FINISH") {
        const { business_id, waba_id, phone_number_id } = payload.data || {};

        console.log("✅ Dados capturados:", {
          business_id,
          waba_id,
          phone_number_id
        });

        // enviar para backend
        handleMetaRegisterWaba({
          idUser: 0,
          facebookUserId: phone_number_id,
          businessId: business_id,
          wabaId: waba_id,
          phoneNumberId: phone_number_id,
        });
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);


  const handleMetaAuth = async (codeAuth: string) => {
    try {
      console.log('[login-auth] Request', codeAuth);

      const response = await apiCore("/Meta/auth", {
        method: "POST",
        body: {
          idUser: 0,
          code: codeAuth
        }
      });

      console.log('[login-Auth] Response', response.data);

    } catch (err) {
      console.error("Erro ao autenticar com Meta", err);
    }
  };

  const handleMetaRegisterWaba = async (data: any) => {
    try {
      console.log('[login-RegisterWaba] Request', data);

      const response = await apiCore("/Meta/RegisterWaba", {
        method: "POST",
        body: data
      });

      console.log('[login-RegisterWaba] Response', response.data);

      // ✅ DESVIO FINAL CORRETO
      if (response.data === true) {
        console.log('[Navigate] dashboard');

        updateUser({
          ...user,
          isFaceCodeAuth: true,
          isFaceTokenAuth: true,
        });

        setRegisterWaba(true);
      }

    } catch (err) {
      console.error("Erro ao RegisterWaba com Meta", err);
    }
  };

  const fbLoginCallback = (response: any) => {
    if (response.authResponse?.code) {
      console.log("🔐 Authorization Code:", response.authResponse.code);

      // enviar code para backend se quiser
      // 👉 chama função async separada
      handleMetaAuth(response.authResponse.code);

    } else {
      console.log("⚠️ Login cancelado", response);
    }
  };

  const launchWhatsAppSignup = () => {
    window.FB.login(fbLoginCallback, {
      config_id: process.env.REACT_APP_FACEBOOK_CONFIG_ID!,
      response_type: "code",
      //redirectUrl: REDIRECT_URI,
      override_default_response_type: true,
      extras: {
        version: "v3",
        featureType: "whatsapp_business_app_onboarding",
        features: [
          { name: "marketing_messages_lite" },
          { name: "app_only_install" }
        ]
      }

    });
  };

  const handleLogin = () => {
    logout();
    setLogin(true);
  }

  // 🚨 Autenticado e conectado meta
  if (login) {
    return <Navigate to="/auth-login" replace />;
  }

  // 🚨 Autenticado e conectado meta
  if (registerWaba) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <NonAuthLayoutWrapper>
      <Row className="justify-content-center my-auto">
        <Col sm={8} lg={6} xl={5}>
          <div className="py-md-5 py-10">

            <AuthHeader title="Autenticação com Facebook" subtitle="Registre-se e comece a utilizar." />

            {/* {success && <Alert fade timeout={150} color="success">Colocar mensagem de sucesso</Alert>}
            {error && <Alert fade timeout={150} color="danger">Colocar mensagem de erro</Alert>} */}

            <div className="text-center mt-0">
              <p>
                <button type="button" className="btn btn-light w-100" id="facebook" onClick={launchWhatsAppSignup}
                  style={{
                    backgroundColor: '#4267b2',
                    color: '#fff',
                    fontSize: '16px',
                    padding: '8px 12px',
                    border: 'none',
                    borderRadius: '4px',
                  }}

                >
                  Entrar com Facebook
                </button>
                <UncontrolledTooltip placement="top" target="facebook">
                  Facebook
                </UncontrolledTooltip>
              </p>
            </div>


            <div className="text-center mt-0">
              <p>
                Não tenho interesse{" "}
                <Button color="default" onClick={handleLogin} className="-mt-2 fw-medium text-decoration-underline"
                  style={{
                    // backgroundColor: '#4267b2',
                    color: '#4eac6d',
                    fontSize: '16px',
                    padding: '8px 12px',
                    border: 'none',
                    borderRadius: '4px',
                  }}
                >
                  Login
                </Button>
                {/* <Link to="/auth-login" className="fw-medium text-decoration-underline">
                  Login
                </Link> */}
              </p>
            </div>

          </div>
        </Col>
      </Row>
    </NonAuthLayoutWrapper >
  )
};

export default FacebookAuth;
